import { render } from "./List.vue?vue&type=template&id=c9be813e"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/vue_apps/auctions_vue/views/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9be813e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9be813e', __exports__)) {
    api.reload('c9be813e', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=c9be813e", () => {
    api.rerender('c9be813e', render)
  })

}


export default __exports__